// Trailer primary-use codes and the "restricted use" UW-review rule. Issue #24533.
// Derived from the `trailersPrimaryUse` lookup in publicLookups.json so the codes never
// drift from the lookup the Staff dropdown renders. Pleasure is the only "clean" usage;
// Business/Residence/Rental open a UW Ops review (Front ticket at bind via the
// `trailerWithRestrictedUse` onboarding task, and at mid-term endorsement via policy-mod).
import publicLookups from './public-lookups/publicLookups.json';

type LookupOption = { id: string; value: string };

const trailersPrimaryUse = (publicLookups as { trailersPrimaryUse: LookupOption[] }).trailersPrimaryUse;

// The single "clean" usage is the one labeled Pleasure — resolved from the lookup rather
// than hardcoding its code, so renaming/recoding the lookup entry can't desync this rule.
const pleasureEntry = trailersPrimaryUse.find(({ value }) => value === 'Pleasure');
if (!pleasureEntry) {
  throw new Error('trailersPrimaryUse lookup is missing its "Pleasure" entry — the restricted-use rule cannot resolve');
}
export const TRAILER_PRIMARY_USE_PLEASURE = pleasureEntry.id;

// Restricted-use code -> human-readable label, for rendering into review tickets.
// Every non-Pleasure lookup entry, keyed by code.
export const trailerRestrictedUseLabels: Record<string, string> = Object.fromEntries(
  trailersPrimaryUse.filter(({ id }) => id !== TRAILER_PRIMARY_USE_PLEASURE).map(({ id, value }) => [id, value])
);

/** A trailer usage that warrants UW review — anything set and not Pleasure. */
export const isRestrictedTrailerUse = (primaryUse?: string | null): boolean =>
  !!primaryUse && primaryUse !== TRAILER_PRIMARY_USE_PLEASURE;
